import {
  AccountBalance,
  Circle,
  Help,
  HelpOutline,
  List,
  Security,
  SettingsInputComponent,
} from "@mui/icons-material";
import Images from "assets/images";
import { menuIcon } from "config/theme";
const menu = [
  {
    id: '01',
    icon: Images.icon.control_panel,
    name: "Panel de control",
    keys: ["Panel de Control"],
    page: "/panel/transacciones",
  },
  {
    id: '02',
    icon: Images.icon.support,
    name: "Soporte",
    keys: ["Soporte", "Proveedores", "Conciliaciones"],
    list: [
      {
        id: '08',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'display_settings',
        name: "Alertas",
        keys: ["Proveedores"],
        page: "/admin/alertas/eventos",
      },
      {
        id: '09',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'display_settings',
        name: "Homologación",
        keys: ["Proveedores"],
        page: "/admin/homologacion",
      },
      {
        id: '09a',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'storage',
        name: "Servidor",
        keys: ["Proveedores"],
        page: "/admin/servidor",
      },
      {
        id: '09c',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'storage',
        name: "Tareas",
        keys: ["Soporte", "Proveedores"],
        page: "/admin/tareas",
      },
      {
        id: 10,
        icon: Images.icon.conciliaciones,
        name: "Conciliaciones",
        keys: ["Conciliaciones"],
        list: [
          {
            id: 11,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            iconTitle: 'fact_check',
            name: "Conciliaciones Reporte",
            keys: ["Conciliaciones"],
            page: "/admin/proveedores/conciliaciones",
          },
          {
            id: 12,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            iconTitle: 'fact_check',
            name: "Conciliaciones Histórico",
            keys: ["Conciliaciones"],
            page: "/admin/proveedores/conciliaciones/history",
          },
          {
            id: 41,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Conciliación Diaria",
            iconTitle: 'plagiarism',
            keys: ["Conciliaciones"],
            page: "/reportes/conciliacion_diaria",
          },
        ],
      },
    ],
  },
  {
    id: '02a',
    icon: <List htmlColor={menuIcon} />,
    name: "Operaciones",
    keys: ["Proveedores"],
    list: [
      {
        id: '04',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'support_agent',
        name: "Monitor de Proveedores",
        keys: ["Proveedores"],
        page: "/admin/proveedores/monitor",
      },
      {
        id: '05',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'support_agent',
        name: "Saldo de Proveedores",
        keys: ["Proveedores"],
        page: "/admin/proveedores/saldo",
      },
      {
        id: '07',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'support_agent',
        name: "Consumos",
        keys: ["Proveedores"],
        page: "/admin/servicios/consumos",
      },
      {
        id: '31a',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'storage',
        name: "Importar a Clientes",
        keys: ["Proveedores"],
        page: "/admin/importar/comercios",
        adminOnly: true,
      },
    ],
  },
  {
    id: 13,
    icon: Images.icon.admin,
    name: "Administración",
    keys: ["Productos", "Proveedores", "Ruteo", "Conectores"],
    list: [
      {
        id: 14,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'category',
        name: "Productos",
        keys: ["Productos"],
        page: "/admin/productos/tae",
      },
      {
        id: 15,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'manage_accounts',
        name: "Proveedores",
        keys: ["Proveedores"],
        page: "/admin/proveedores",
      },
      {
        id: 16,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'manage_accounts',
        name: "Carriers",
        keys: ["Proveedores"],
        page: "/admin/proveedores/carriers",
      },
      // {
      //   id: '09d',
      //   icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
      //   iconTitle: 'storage',
      //   name: "Asignacion de productos",
      //   keys: ["Proveedores"],
      //   page: "/admin/asignacion-productos/proveedores/tae",
      // },
      // {
      //   id: 17,
      //   icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
      //   iconTitle: 'manage_accounts',
      //   name: "Conectores",
      //   keys: ["Conectores"],
      //   page: "/admin/conectores",
      // },
      // {
      //   icon: <Circle htmlColor='#ffffff' sx={{ width: 10, height: 10 }} />,
      // iconTitle: 'manage_accounts',
      //   name: 'Conciliaciones Reporte',
      //   keys: ['Conciliaciones', 'Reportes'],
      //   page: '/admin/proveedores/conciliaciones',
      // },
      // {
      //   icon: <Circle htmlColor='#ffffff' sx={{ width: 10, height: 10 }} />,
      // iconTitle: 'manage_accounts',
      //   name: 'Conciliaciones Histórico',
      //   keys: ['Conciliaciones', 'Reportes'],
      //   page: '/admin/proveedores/conciliaciones/history',
      // },
      {
        id: 18,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'manage_accounts',
        name: "Códigos de error",
        keys: ["Proveedores"],
        page: "/admin/proveedores/hebecodes",
      },
      {
        id: '09d',
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'storage',
        name: "Asignacion de productos",
        keys: ["Proveedores"],
        page: "/admin/asignacion-productos/proveedores/tae",
      },
    ],
  },
  {
    id: 19,
    icon: <SettingsInputComponent htmlColor={menuIcon} />,
    name: "Ruteo",
    keys: ["Ruteo", "Simulador"],
    list: [
      {
        id: 20,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Ladas",
        iconTitle: 'settings_phone',
        keys: ["Ruteo"],
        page: "/ruteo/ladas",
      },
      {
        id: 21,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Panel de Ruteo",
        iconTitle: 'display_settings',
        keys: ["Ruteo"],
        page: "/ruteo/panel/tae",
      },
      {
        id: 22,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Simulador",
        iconTitle: 'terminal',
        keys: ["Ruteo"],
        page: "/ruteo/simulador",
      },
    ],
  },
  {
    id: 23,
    icon: <Security htmlColor={menuIcon} />,
    name: "Seguridad",
    keys: ["Administradores", "Usuarios", "Roles", "Permisos"],
    list: [
      {
        id: 24,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Administradores",
        iconTitle: 'admin_panel_settings',
        keys: ["Administradores"],
        page: "/seguridad/administradores",
      },
      {
        id: 25,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Roles",
        iconTitle: 'perm_contact_calendar',
        keys: ["Roles"],
        page: "/seguridad/roles",
      },
      {
        id: 26,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Permisos",
        iconTitle: 'lock_person',
        keys: ["Permisos"],
        page: "/seguridad/permisos",
      },
    ],
  },
  {
    id: 27,
    icon: Images.icon.clientes,
    name: "Clientes",
    keys: ["Comercios", "Árbol de Comercios", "Bolsas", "Puntos de Venta", "Grupos"],
    list: [
      {
        id: 28,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'group',
        name: "Grupos",
        keys: ["Comercios"],
        page: "/cliente/grupos",
      },
      {
        id: 29,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'storefront',
        name: "Comercios",
        keys: ["Comercios"],
        page: "/cliente/comercios",
      },
      {
        id: 129,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'account_tree',
        name: "Árbol de Comercios",
        keys: ["Árbol de Comercios"],
        page: "/cliente/arbol_comercios",
      },
      {
        id: 30,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Bolsas",
        iconTitle: 'bussiness_center',
        keys: ["Bolsas"],
        page: "/cliente/bolsas",
      },
      {
        id: 31,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: 'point_of_sale',
        name: "Puntos de Venta",
        keys: ["Puntos de Venta"],
        page: "/cliente/puntos_de_venta",
      },
    ],
  },
  {
    id: 32,
    icon: Images.icon.reportes,
    name: "Reportes",
    keys: ["Detallado", "Saldos", "Reportes"],
    list: [
      {
        id: 33,
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        name: "Reporte detallado",
        iconTitle: Images.icon.conciliaciones,
        keys: ["Detallado", "Reportes"],
        page: "/reportes/detallado",
      },
      {
        id: 'administrativo',
        icon: <List htmlColor={menuIcon} />,
        name: "Administrativo",
        keys: ["Reportes"],
        list: [
          {
            id: 37,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Registros Bitacora",
            iconTitle: 'plagiarism',
            keys: ["Bitacora", "Reportes"],
            page: "/reportes/bitacora",
          },
          {
            id: 40,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Liberaciones Distribuidor",
            iconTitle: 'plagiarism',
            keys: ["Reporte Liberaciones"],
            page: "/reportes/liberaciones",
            hover: "Muestra los abonos de saldo hechos por el DISTRIBUIDOR , en caso de hebe, muestra los de COMTODOTEL este reporte solo se muestra en ADMIN y Distribuidor"
          },
          {
            id: 'busqueda',
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Búsqueda TX ",
            iconTitle: 'plagiarism',
            keys: ["Buscar Transacción"],
            page: "/reportes/buscar_txn",
          },
          {
            id: 'comportamiento',
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Reporte de comportamiento",
            iconTitle: 'plagiarism',
            keys: ["Reportes"],
            page: "/reportes/comportamiento",
          },
          {
            id: 41,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Reportes por correo",
            iconTitle: 'plagiarism',
            keys: ["Reportes por Correo"],
            page: "/reportes/correos",
          },
          {
            id: 'backup',
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Aprobadas Backup",
            iconTitle: 'plagiarism',
            keys: ["Aprobadas Backup"],
            page: "/reportes/backup",
          },
        ]
      },
      {
        id: 'comercio',
        icon: <List htmlColor={menuIcon} />,
        name: "Por Comercio",
        keys: ["Reportes"],
        list: [
          {
            id: 34,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Estado de cuenta diario",
            iconTitle: 'account_balance_wallet',
            keys: ["Saldos", "Reportes"],
            page: "/reportes/saldos",
            hover: 'Resumen diario de un comercio con seguimiento de saldo'
          },
          {
            id: 36,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Saldo diario Inicial",
            iconTitle: 'plagiarism',
            keys: ["SaldoDiario", "Reportes"],
            page: "/reportes/saldo_diario",
            hover: 'Saldo de cierre diario de todos los comercios'
          },
          {
            id: 40,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Abonos por mes",
            iconTitle: 'plagiarism',
            keys: ["Reporte Abonos"],
            page: "/reportes/abonos",
            hover: 'Muestra los abonos de saldo de un comercio receptor por mes'
          },
          {
            id: 39,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Operaciones Comercio",
            iconTitle: 'plagiarism',
            keys: ["Reporte Comercio"],
            page: "/reportes/comercio",
            hover: 'Muestra todas las operaciones de un comercio incluidos ABONOS, con seguimiento de saldo'
          },
          {
            id: 35,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Totales por operadora",
            iconTitle: 'plagiarism',
            keys: ["Totales", "Reportes"],
            page: "/reportes/totales",
            hover: 'Reporte de Totales por Operadora y por Comercio'
          },
          {
            id: 38,
            icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
            name: "Reporte de red",
            iconTitle: 'plagiarism',
            keys: ["Red", "RedAdmin"],
            page: "/reportes/red",
          },
        ]
      },
    ],
  },
  {
    id: "abonos",
    icon: <AccountBalance htmlColor={menuIcon} />,
    name: "Abonos",
    keys: ["Abonos", "Administrar Abonos"],
    list: [
      {
        id: "abonos_admin",
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: "account_balance",
        name: "Administración de Abonos",
        keys: ["Administrar Abonos"],
        page: "/abonos/admin",
      },
      {
        id: "abonos_lista",
        icon: <Circle htmlColor={menuIcon} sx={{ width: 10, height: 10 }} />,
        iconTitle: "payments",
        name: "Abonos",
        keys: ["Notificar Abonos"],
        page: "/abonos/comercio",
      },
    ],
  },
  {
    id: "ayuda",
    icon: <Help htmlColor={menuIcon} />,
    iconTitle: 'help',
    name: "Ayuda",
    keys: [],
    page: "/ayuda/manual-administrador",
    alwaysVisible: true,
  },
];

export const categories = menu.reduce(
  (prev, item) => [...prev, ...item.keys],
  []
);

export default menu;
